<template>
    <div class="fst-SearchList fst-SearchListItem" :class="[
        type,
        `curStep-${tour.curStep.index}`,
        {'tour-show-step': tourStep == '5'}
        ]" ref="list">
        <span class="exportBtn"
              v-if="type === 'Favorites' && !exportMenuVisible && result.list.length"
              @click="exportMenuVisible=true">
            <img src="export2xls_icon.png" alt="Export to Excel">
        </span>
        <span class="exportMenu" v-if="exportMenuVisible" v-loading="exportLoading">
            <span class="closeMenu" @click="handleCloseExportMenu"><i class="far fa-times"></i></span>
            <button class="btn" @click="$emit('handleExportDocs', {all: true})">
                <span v-html="$t('export.all')"></span>
            </button>
            <button class="btn" :disabled="exportCheckedDisabled"
                    @click="$emit('handleExportDocs', {all: false})">{{$t('export.checked')}} ({{ exportCheckedCount }})
            </button>
        </span>

        <summarization-block v-if="summarization.show"></summarization-block>

        <div v-for="(item, key) in result.list" :key="key" class="list-item-container">
            <a :id="`doc${key}`" v-if="params.showNumber"></a>
            <el-checkbox v-model="item.checked"
                         v-if="exportMenuVisible"
                         @change="handleSelectDoc(item)"></el-checkbox>
            <div :ref="`list-item-${item.id}`"
                 :data-role="`type-${item.type}`"
                 :class="[
                     'list-item',
                    {isRemove: item.isRemove},
                    {isViewed: item.isViewed && type !== 'Favorites'},
                    {highlightTitle: tour.highlight.Title},
                    {highlightDescription: tour.highlight.FullText}
                    ]"
                 @click="handleFavCheck($event,item)">
                <div class="logo" v-if="item.urlLogo && type !== 'Favorites'">
                    <el-link :underline="false" @click="handleClickTitle(item)">
                        <img :src="item.urlLogo" alt="Company Logo" onerror="this.src='noLogo.png'">
                    </el-link>
                </div>
                <div class="sl-content flex-1">
                    <div class="type" v-if="type === 'Favorites'">{{ item.type }}</div>
                    <div class="title-block" v-if="item.title">
                        <div class="title">
                            <div class="titleNum">

                                <el-link :underline="false" @click="handleClickTitle(item)">
                                    <!--span class="num">{{key+1}}. </span-->
                                    <div class="number" v-if="params.showNumber">{{key+1}}</div>
                                    <DocumentText v-if="item.translation.show" :text="item.translation.title"
                                                  :docType="item.type" :hostingName="item.hostingName"/>
                                    <DocumentText v-else :text="item.title" :docType="item.type"
                                                  :hostingName="item.hostingName"/>
                                </el-link>
                            </div>
                            <div class="docType mt-2" v-if="params.showDocType">
                                <el-tag type="primary">{{$t('searchMode.source.' + item.type)}}</el-tag>
                            </div>
                        </div>
                        <div class="toolsBtns">
                            <el-link v-if="isDev" :underline="false" class="moreLikeLink" icon="far fa-code"
                                     title="Show document source" @click="showDevDialog(item)"/>
                            <el-link v-if="isAdmin" :underline="false" class="moreLikeLink" icon="far fa-trash"
                                     title="Delete document"
                                     @click="deleteDocuments([{id: item.id, type: item.type}])"/>
                            <el-tooltip class="item" effect="dark" content="Viewed document"
                                        :open-delay="900" placement="top-start">
                                <el-link :underline="false" class="moreLikeLink"
                                         v-if="item.isViewed && type !== 'Favorites'" icon="far fa-eye"
                                         @click="toggleViewDoc(item, false)"/>
                            </el-tooltip>
                            <template v-if="item.urlsOther">
                                <el-tooltip class="item" effect="dark" content="Open PDF"
                                            :open-delay="900" placement="top-start">

                                    <template v-if="Array.isArray(item.urlsOther) && item.urlsOther.length > 1">
                                        <el-dropdown @command="handleOpenLink" placement="bottom">
                                  <span class="el-dropdown-link  moreLikeLink">
                                        <i class="fal fa-file-pdf mr-1"></i>
                                  </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item v-for="(pdf, pdkey) in item.urlsOther" :key="pdkey"
                                                                  :command="pdf">{{cropFileName(pdf)}}
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </template>
                                    <template v-else-if="(typeof item.urlsOther === 'string') || item.urlsOther[0]">
                                        <el-link class="moreLikeLink"
                                                 :underline="false" icon="fal fa-file-pdf"
                                                 :href="(typeof item.urlsOther === 'string') ? item.urlsOther : item.urlsOther[0]"
                                                 target="_blank">
                                        </el-link>
                                    </template>
                                </el-tooltip>
                            </template>
                            <template v-if="item.urlCrunchbase && item.url">
                                <el-dropdown @command="handleOpenLink" placement="top">
                                  <span class="el-dropdown-link  moreLikeLink">
                                        <i class="fas fa-share"></i>
                                  </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="item.url">Open company website</el-dropdown-item>
                                        <el-dropdown-item :command="item.urlCrunchbase">Open Crunchbase link
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                            <template v-else>
                                <el-tooltip class="item" effect="dark" content="Link to Crunchbase"
                                            v-if="item.urlCrunchbase && item.urlCrunchbase.includes('http')"
                                            :open-delay="900" placement="top-start">
                                    <el-link :underline="false" class="moreLikeLink"
                                             icon="fas fa-share" target="_blank"
                                             :href="item.urlCrunchbase"/>
                                    <!--a class="moreLikeLink"
                                       target="_blank"
                                       :href="item.urlCrunchbase">
                                        <img class="linkIcon"
                                             src="data:image/svg+xml;base64,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">
                                    </a-->
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Open source"
                                            v-if="item.url && item.url.includes('http')"
                                            :open-delay="900" placement="top-start">
                                    <el-link :underline="false" class="moreLikeLink"
                                             icon="fas fa-share" target="_blank"
                                             :href="item.url"/>
                                </el-tooltip>
                            </template>
                        </div>
                    </div>
                    <div class="description" @click="handleCollapseTranslation(item)"
                         :class="{collapse: item.translation.collapse}"
                         v-if="item.translation.show">
                        <DocumentText :text="item.translation.description" :docType="item.type"
                                      :hostingName="item.hostingName"/>
                    </div>
                    <div class="description" v-else-if="item.description.fragments || item.description.full"
                         @click="toggleFullText(item)" :class="{full: item.description.showFull}">
                        <template v-if="item.description.fragments">
                            <div v-if="!item.description.showFull">
                                <DocumentText :text="item.description.fragments" :docType="item.type"
                                              :hostingName="item.hostingName"/>
                            </div>
                            <div v-else>
                                <div v-if="item.ftDesc" class="fullTextDesc">
                                    <div v-for="(ft,ind) in item.ftDesc" :key="ind">
                                        <DocumentText :text="ft" :docType="item.type"
                                                      :hostingName="item.hostingName"/>
                                        ...
                                    </div>
                                </div>
                                <div>
                                    <DocumentText :text="item.description.full" :docType="item.type"
                                                  :hostingName="item.hostingName"/>
                                </div>
                            </div>
                            <el-link type="primary" :underline="false" v-if="item.description.full">
                                <span>{{ item.description.showFull ? $t('label.showLess') : $t('label.showMore') }}</span>
                            </el-link>
                        </template>
                        <template v-else>
                            <DocumentText :text="item.description.full" :docType="item.type"
                                          :hostingName="item.hostingName"/>
                        </template>
                    </div>
                    <slot name="belowDescription" v-bind:item="item"></slot>
                    <!-- News -->
                    <template v-if="['News', 'RuNews'].includes(item.type)">
                        <CollapseTags v-model="item.sysTags" type="danger" v-if="isDev || isAdmin"></CollapseTags>
                        <CollapseTags v-model="item.keywords" type="green"></CollapseTags>
                        <UserTags
                                v-model="item.userTags"
                                v-if="!params.hideUserTags"
                                :fullUserTagList="fullUserTagList"
                                :doc="item"
                                @userTagAction="userTagAction(item)"
                                @updateUserTagList="updateUserTagList"
                                :class="['my-1', {highlighted: tour.highlight.Tag}]">
                        </UserTags>
                        <div class="attrs-wrap">
                            <div class="attrs">
                                <div class="attrs-item" v-if="item.date"><span>{{ item.date }}</span></div>
                                <a :href="item.url" target="_blank" class="attrs-item" v-html="item.website"
                                   :title="item.hostingName"></a>
                            </div>
                            <div class="favs"
                                 :class="[
                                     {noLabels: noLabels},
                                     {highlightTranslate: tour.highlight.Translate},
                                     {highlightMoreLikeThis: tour.highlight.MoreLikeThis},
                                     ]">
                                <el-popover
                                        placement="bottom"
                                        popper-class="searchList-note"
                                        :visible-arrow="true"
                                        title=""
                                        width="410"
                                        trigger="manual"
                                        v-model="item.noteVisible">
                                    <el-input class="notes"
                                              v-model="item.noteEdit"
                                              @input="handleValidateUserNote(item)"
                                              type="textarea"
                                              :show-word-limit="true"
                                              :maxlength="maxNoteSize"
                                              clearable
                                              :autosize=" { minRows: 2, maxRows: 10 }"
                                              :placeholder="$t('writeYourNotesHere')"></el-input>
                                    <div class="notes">
                                    </div>
                                    <div class="control">
                                        <el-link type="text" @click="item.noteEdit = ''"
                                                 class="px-3 py-1"
                                                 :underline="false">
                                            <i class="fas fa-trash-alt iq-text-danger"></i>
                                        </el-link>

                                        <div v-if="item.error" class="error">
                                            <i class="fas fa-exclamation-triangle"></i>
                                            {{ item.error }}
                                        </div>

                                        <div class="nowrap">
                                            <el-button type="text" @click="handleCancelNote(item)"
                                                       v-html="$t('cancel')"></el-button>
                                            <el-button type="primary"
                                                       @click="handleSaveNote(item)"
                                                       :disabled="item.error.length > 0"
                                                       v-html="$t('save')">
                                            </el-button>
                                        </div>
                                    </div>
                                    <el-link slot="reference" :underline="false"
                                             class="moreLikeLink"
                                             :class="[{active: item.note}]"
                                             @click="handleToggleNote(item)">
                                        <i class="fa-sticky-note fas"></i>
                                        <span class="label" v-html="$t('label.notes')"></span>
                                    </el-link>
                                </el-popover>

                                <el-link :underline="false" class="moreLikeLink"
                                         v-for="lang in languages" :key="lang.name"
                                         v-if="isTranslationAvailable"
                                         @click="handleTranslateItem(item,lang.name)"
                                         :class="{active: item.lang === lang.name}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                         fill="none" style="position: relative;top: 6px; margin: -5px -5px 0 0;">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M7.99358 2.99986C8.54587 2.99986 8.99358 3.44758 8.99358 3.99986V4.70257H10.7807C10.7944 4.70228 10.8081 4.70228 10.8218 4.70257H12.3269C12.8792 4.70257 13.3269 5.15028 13.3269 5.70257C13.3269 6.25485 12.8792 6.70257 12.3269 6.70257H11.5715C11.3942 7.2829 11.1626 7.87554 10.8992 8.42696C10.5212 9.21867 10.0426 9.99981 9.50681 10.5411C9.49852 10.5495 9.49011 10.5579 9.48159 10.5664C9.98959 11.0649 10.5269 11.548 11.0479 11.9289L12.5915 7.71029C12.736 7.3153 13.1123 7.05297 13.5329 7.05392C13.9535 7.05487 14.3285 7.31889 14.4713 7.71452L16.6202 13.6705L17.4241 15.6184C17.6348 16.1289 17.3918 16.7135 16.8812 16.9242C16.3707 17.1349 15.7861 16.8919 15.5754 16.3813L15.0181 15.0311H11.9972L11.3972 16.401C11.1757 16.9069 10.5859 17.1374 10.0801 16.9159C9.57416 16.6943 9.34367 16.1046 9.56524 15.5987L10.3273 13.8588C9.44283 13.2896 8.59741 12.5108 7.92665 11.8415C7.75135 11.971 7.57421 12.0992 7.39996 12.2233C6.59587 12.7958 5.76548 13.3424 5.28655 13.621C4.80917 13.8987 4.19704 13.7368 3.91933 13.2595C3.64162 12.7821 3.80348 12.17 4.28086 11.8922C4.68465 11.6573 5.45919 11.1499 6.23999 10.594C6.33483 10.5265 6.42856 10.4591 6.52064 10.3922C5.97063 9.79109 5.43925 9.14158 5.1081 8.53017C4.84507 8.04454 5.02553 7.43764 5.51116 7.17461C5.99679 6.91158 6.60369 7.09203 6.86672 7.57766C7.1194 8.04418 7.56729 8.58074 8.08367 9.13589C8.08422 9.13535 8.08476 9.1348 8.0853 9.13426C8.39776 8.81855 8.76175 8.26185 9.09446 7.56512C9.22851 7.28441 9.35171 6.99312 9.46021 6.70257H3.49976C2.94747 6.70257 2.49976 6.25485 2.49976 5.70257C2.49976 5.15028 2.94747 4.70257 3.49976 4.70257H6.99358V3.99986C6.99358 3.44758 7.4413 2.99986 7.99358 2.99986ZM12.7743 13.0311H14.2633L13.524 10.9821L12.7743 13.0311Z"></path>
                                    </svg>

                                    <span class="label" v-html="$t('label.translate')"></span>
                                </el-link>
                                <el-link :underline="false" class="moreLikeLink"
                                         v-if="!noLikeThis"
                                         @click="handleMoreLikeClick(item)">
                                    <i class="fas fa-copy"></i>
                                    <span class="label" v-html="$t('label.moreLikeThis')"></span>
                                </el-link>
                            </div>
                        </div>
                    </template>
                    <!-- Science -->
                    <template v-else-if="['Science','ScienceCrossref','ScienceOpenAlex'].includes(item.type)">
                        <CollapseTags v-model="item.sysTags" type="danger" v-if="isDev || isAdmin"></CollapseTags>
                        <CollapseTags v-model="item.keywords"
                                      type="green"
                                      :hostingName="item.hostingName"
                                      :docType="item.type"
                                      :title="isDev ? (item.systemKeywords || []).length ? 'System keywords' : 'Author keywords' : ''">
                        </CollapseTags>
                        <UserTags v-model="item.userTags"
                                  :fullUserTagList="fullUserTagList"
                                  :doc="item"
                                  @userTagAction="userTagAction(item)"
                                  @updateUserTagList="updateUserTagList"
                                  :class="['my-1', {highlighted: tour.highlight.Tag}]">
                        </UserTags>
                        <div class="attrs-wrap">
                            <div class="attrs d-flex">
                                <div class="attrs-item nowrap noshrink" v-if="item.date"><span>{{ item.date }}</span>
                                </div>
                                <el-tooltip class="item" effect="dark"
                                            :content="`Authors' countries: ${$utils.stripTags(item.countries.join(', '))}`"
                                            :open-delay="1000" placement="top-start" v-if="item.countriesFormat">

                                    <div class="attrs-item nowrap" v-html="item.countriesFormat"
                                         v-if="item.countriesFormat"></div>
                                </el-tooltip>

                                <el-tooltip class="item" effect="dark"
                                            :content="'Authors\' organizations: ' + item.companies.join(', ')"
                                            :open-delay="1000" placement="top-start" v-if="item.companiesFormat">
                                    <div class="attrs-item ellipsis" v-html="item.companiesFormat"></div>
                                </el-tooltip>

                                <el-tooltip class="item" effect="dark" :content="'Journal: ' + item.journalName"
                                            v-if="item.journalName"
                                            :open-delay="1000" placement="top-start">
                                    <div class="attrs-item nowrap" v-html="item.journalName"></div>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" :content="'Publisher: ' + item.publisher"
                                            v-else-if="item.publisher"
                                            :open-delay="1000" placement="top-start">
                                    <div class="attrs-item nowrap" v-html="item.publisher"></div>
                                </el-tooltip>
                            </div>
                            <div class="favs" :class="[
                                     {noLabels: noLabels},
                                     {highlightTranslate: tour.highlight.Translate},
                                     {highlightMoreLikeThis: tour.highlight.MoreLikeThis},
                                     ]">
                                <el-popover
                                        placement="bottom"
                                        popper-class="searchList-note"
                                        :visible-arrow="true"
                                        title=""
                                        width="410"
                                        trigger="manual"
                                        v-model="item.noteVisible">
                                    <el-input class="notes"
                                              v-model="item.noteEdit"
                                              @input="handleValidateUserNote(item)"
                                              type="textarea"
                                              :show-word-limit="true"
                                              :maxlength="maxNoteSize"
                                              clearable
                                              :autosize=" { minRows: 2, maxRows: 10 }"
                                              :placeholder="$t('writeYourNotesHere')"></el-input>
                                    <div class="notes">
                                    </div>
                                    <div class="control">
                                        <el-link type="text" @click="item.noteEdit = ''"
                                                 class="px-3 py-1"
                                                 :underline="false">
                                            <i class="fas fa-trash-alt iq-text-danger"></i>
                                        </el-link>

                                        <div v-if="item.error" class="error">
                                            <i class="fas fa-exclamation-triangle"></i>
                                            {{ item.error }}
                                        </div>

                                        <div class="nowrap">
                                            <el-button type="text" @click="handleCancelNote(item)"
                                                       v-html="$t('cancel')"></el-button>
                                            <el-button type="primary"
                                                       @click="handleSaveNote(item)"
                                                       :disabled="item.error.length > 0"
                                                       v-html="$t('save')">
                                            </el-button>
                                        </div>
                                    </div>
                                    <el-link slot="reference" :underline="false"
                                             class="moreLikeLink"
                                             :class="[{active: item.note}]"
                                             @click="handleToggleNote(item)">
                                        <i class="fa-sticky-note fas"></i>
                                        <span class="label" v-html="$t('label.notes')"></span>
                                    </el-link>
                                </el-popover>

                                <el-link :underline="false" class="moreLikeLink"
                                         v-for="lang in languages" :key="lang.name"
                                         @click="handleTranslateItem(item,lang.name)"
                                         :class="{active: item.lang === lang.name}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                         fill="none" style="position: relative;top: 5px; margin: -5px -4px 0 0;">

                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M7.99358 2.99986C8.54587 2.99986 8.99358 3.44758 8.99358 3.99986V4.70257H10.7807C10.7944 4.70228 10.8081 4.70228 10.8218 4.70257H12.3269C12.8792 4.70257 13.3269 5.15028 13.3269 5.70257C13.3269 6.25485 12.8792 6.70257 12.3269 6.70257H11.5715C11.3942 7.2829 11.1626 7.87554 10.8992 8.42696C10.5212 9.21867 10.0426 9.99981 9.50681 10.5411C9.49852 10.5495 9.49011 10.5579 9.48159 10.5664C9.98959 11.0649 10.5269 11.548 11.0479 11.9289L12.5915 7.71029C12.736 7.3153 13.1123 7.05297 13.5329 7.05392C13.9535 7.05487 14.3285 7.31889 14.4713 7.71452L16.6202 13.6705L17.4241 15.6184C17.6348 16.1289 17.3918 16.7135 16.8812 16.9242C16.3707 17.1349 15.7861 16.8919 15.5754 16.3813L15.0181 15.0311H11.9972L11.3972 16.401C11.1757 16.9069 10.5859 17.1374 10.0801 16.9159C9.57416 16.6943 9.34367 16.1046 9.56524 15.5987L10.3273 13.8588C9.44283 13.2896 8.59741 12.5108 7.92665 11.8415C7.75135 11.971 7.57421 12.0992 7.39996 12.2233C6.59587 12.7958 5.76548 13.3424 5.28655 13.621C4.80917 13.8987 4.19704 13.7368 3.91933 13.2595C3.64162 12.7821 3.80348 12.17 4.28086 11.8922C4.68465 11.6573 5.45919 11.1499 6.23999 10.594C6.33483 10.5265 6.42856 10.4591 6.52064 10.3922C5.97063 9.79109 5.43925 9.14158 5.1081 8.53017C4.84507 8.04454 5.02553 7.43764 5.51116 7.17461C5.99679 6.91158 6.60369 7.09203 6.86672 7.57766C7.1194 8.04418 7.56729 8.58074 8.08367 9.13589C8.08422 9.13535 8.08476 9.1348 8.0853 9.13426C8.39776 8.81855 8.76175 8.26185 9.09446 7.56512C9.22851 7.28441 9.35171 6.99312 9.46021 6.70257H3.49976C2.94747 6.70257 2.49976 6.25485 2.49976 5.70257C2.49976 5.15028 2.94747 4.70257 3.49976 4.70257H6.99358V3.99986C6.99358 3.44758 7.4413 2.99986 7.99358 2.99986ZM12.7743 13.0311H14.2633L13.524 10.9821L12.7743 13.0311Z"></path>
                                    </svg>

                                    <span class="label" v-html="$t('label.translate')"></span>
                                </el-link>
                                <el-link :underline="false" class="moreLikeLink"
                                         v-if="!noLikeThis"
                                         @click="handleMoreLikeClick(item)">
                                    <i class="fas fa-copy"></i>
                                    <span class="label" v-html="$t('label.moreLikeThis')"></span>
                                </el-link>

                            </div>
                        </div>
                    </template>
                    <!-- Patents -->
                    <template v-else-if="item.type === 'Patents'">
                        <CollapseTags v-model="item.sysTags" type="danger" v-if="isDev || isAdmin"></CollapseTags>
                        <CollapseTags v-model="item.keywords" type="green"></CollapseTags>
                        <UserTags
                                v-model="item.userTags"
                                :fullUserTagList="fullUserTagList"
                                :doc="item"
                                @userTagAction="userTagAction(item)"
                                @updateUserTagList="updateUserTagList"
                                :class="['my-1', {highlighted: tour.highlight.Tag}]">
                        </UserTags>
                        <div class="attrs-wrap">
                            <div class="attrs">
                                <div class="attrs-item" v-if="item.date"><span>{{ item.date }}</span></div>
                                <div class="attrs-item" :title="item.companiesFormat"
                                     v-html="item.companiesFormat"></div>
                                <div class="attrs-item">
                                    <IqLink type="primary" :href="item.url" :underline="false" target="_blank"
                                            @click.stop.prevent="handleClickTitle(item)">{{ item.id }}
                                    </IqLink>
                                </div>
                            </div>
                            <div class="favs" :class="[
                                     {noLabels: noLabels},
                                     {highlightTranslate: tour.highlight.Translate},
                                     {highlightMoreLikeThis: tour.highlight.MoreLikeThis},
                                     ]">
                                <el-popover
                                        placement="bottom"
                                        popper-class="searchList-note"
                                        :visible-arrow="true"
                                        title=""
                                        width="410"
                                        trigger="manual"
                                        v-model="item.noteVisible">
                                    <el-input class="notes"
                                              v-model="item.noteEdit"
                                              @input="handleValidateUserNote(item)"
                                              type="textarea"
                                              :show-word-limit="true"
                                              :maxlength="maxNoteSize"
                                              clearable
                                              :autosize=" { minRows: 2, maxRows: 10 }"
                                              :placeholder="$t('writeYourNotesHere')"></el-input>
                                    <div class="notes">
                                    </div>
                                    <div class="control">
                                        <el-link type="text" @click="item.noteEdit = ''"
                                                 class="px-3 py-1"
                                                 :underline="false">
                                            <i class="fas fa-trash-alt iq-text-danger"></i>
                                        </el-link>

                                        <div v-if="item.error" class="error">
                                            <i class="fas fa-exclamation-triangle"></i>
                                            {{ item.error }}
                                        </div>

                                        <div class="nowrap">
                                            <el-button type="text" @click="handleCancelNote(item)"
                                                       v-html="$t('cancel')"></el-button>
                                            <el-button type="primary"
                                                       @click="handleSaveNote(item)"
                                                       :disabled="item.error.length > 0"
                                                       v-html="$t('save')">
                                            </el-button>
                                        </div>
                                    </div>
                                    <el-link slot="reference" :underline="false"
                                             class="moreLikeLink"
                                             :class="[{active: item.note}]"
                                             @click="handleToggleNote(item)">
                                        <i class="fa-sticky-note fas"></i>
                                        <span class="label" v-html="$t('label.notes')"></span>
                                    </el-link>
                                </el-popover>
                                <el-link :underline="false" class="moreLikeLink"
                                         v-for="lang in languages" :key="lang.name"
                                         @click="handleTranslateItem(item,lang.name)"
                                         :class="{active: item.lang === lang.name}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                         fill="none" style="position: relative;top: 5px; margin: -5px -4px 0 0;">

                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M7.99358 2.99986C8.54587 2.99986 8.99358 3.44758 8.99358 3.99986V4.70257H10.7807C10.7944 4.70228 10.8081 4.70228 10.8218 4.70257H12.3269C12.8792 4.70257 13.3269 5.15028 13.3269 5.70257C13.3269 6.25485 12.8792 6.70257 12.3269 6.70257H11.5715C11.3942 7.2829 11.1626 7.87554 10.8992 8.42696C10.5212 9.21867 10.0426 9.99981 9.50681 10.5411C9.49852 10.5495 9.49011 10.5579 9.48159 10.5664C9.98959 11.0649 10.5269 11.548 11.0479 11.9289L12.5915 7.71029C12.736 7.3153 13.1123 7.05297 13.5329 7.05392C13.9535 7.05487 14.3285 7.31889 14.4713 7.71452L16.6202 13.6705L17.4241 15.6184C17.6348 16.1289 17.3918 16.7135 16.8812 16.9242C16.3707 17.1349 15.7861 16.8919 15.5754 16.3813L15.0181 15.0311H11.9972L11.3972 16.401C11.1757 16.9069 10.5859 17.1374 10.0801 16.9159C9.57416 16.6943 9.34367 16.1046 9.56524 15.5987L10.3273 13.8588C9.44283 13.2896 8.59741 12.5108 7.92665 11.8415C7.75135 11.971 7.57421 12.0992 7.39996 12.2233C6.59587 12.7958 5.76548 13.3424 5.28655 13.621C4.80917 13.8987 4.19704 13.7368 3.91933 13.2595C3.64162 12.7821 3.80348 12.17 4.28086 11.8922C4.68465 11.6573 5.45919 11.1499 6.23999 10.594C6.33483 10.5265 6.42856 10.4591 6.52064 10.3922C5.97063 9.79109 5.43925 9.14158 5.1081 8.53017C4.84507 8.04454 5.02553 7.43764 5.51116 7.17461C5.99679 6.91158 6.60369 7.09203 6.86672 7.57766C7.1194 8.04418 7.56729 8.58074 8.08367 9.13589C8.08422 9.13535 8.08476 9.1348 8.0853 9.13426C8.39776 8.81855 8.76175 8.26185 9.09446 7.56512C9.22851 7.28441 9.35171 6.99312 9.46021 6.70257H3.49976C2.94747 6.70257 2.49976 6.25485 2.49976 5.70257C2.49976 5.15028 2.94747 4.70257 3.49976 4.70257H6.99358V3.99986C6.99358 3.44758 7.4413 2.99986 7.99358 2.99986ZM12.7743 13.0311H14.2633L13.524 10.9821L12.7743 13.0311Z"></path>
                                    </svg>
                                    <span class="label" v-html="$t('label.translate')"></span>
                                </el-link>
                                <el-link :underline="false" class="moreLikeLink"
                                         v-if="!noLikeThis"
                                         @click="handleMoreLikeClick(item)">
                                    <i class="fas fa-copy"></i>
                                    <span class="label" v-html="$t('label.moreLikeThis')"></span>
                                </el-link>
                            </div>
                        </div>
                    </template>
                    <!-- Companies -->
                    <template v-else-if="item.type === 'Companies'">
                        <CollapseTags v-model="item.sysTags" type="danger" v-if="isDev || isAdmin"></CollapseTags>
                        <CollapseTags v-model="item.keywords" type="green"></CollapseTags>
                        <UserTags
                                v-model="item.userTags"
                                :fullUserTagList="fullUserTagList"
                                :doc="item"
                                @userTagAction="userTagAction(item)"
                                @updateUserTagList="updateUserTagList"
                                :class="['my-1', {highlighted: tour.highlight.Tag}]">
                        </UserTags>
                        <div class="attrs-wrap">
                            <el-tooltip effect="light" :open-delay="900" placement="top">
                                <div slot="content">Company rank: {{item.companyRank}}</div>
                                <div class="attrs">
                                    <div class="attrs-item investmentTotal" v-if="item.investmentTotal">
                                        $ {{ item.investmentFormat }}
                                    </div>
                                    <div class="attrs-item" v-if="item.founded" @click="toggleIconSize()">
                                        <span v-html="item.founded"></span>
                                    </div>
                                    <div class="attrs-item" v-if="item.url">
                                        <IqLink type="primary" :href="item.url" :underline="false" target="_blank">
                                            Website
                                        </IqLink>
                                    </div>
                                </div>
                            </el-tooltip>
                            <div class="favs" :class="[
                                     {noLabels: noLabels},
                                     {highlightTranslate: tour.highlight.Translate},
                                     {highlightMoreLikeThis: tour.highlight.MoreLikeThis},
                                     ]">
                                <el-popover
                                        placement="bottom"
                                        popper-class="searchList-note"
                                        :visible-arrow="true"
                                        title=""
                                        width="410"
                                        trigger="manual"
                                        v-model="item.noteVisible">
                                    <el-input class="notes"
                                              v-model="item.noteEdit"
                                              @input="handleValidateUserNote(item)"
                                              type="textarea"
                                              :show-word-limit="true"
                                              :maxlength="maxNoteSize"
                                              clearable
                                              :autosize=" { minRows: 2, maxRows: 10 }"
                                              :placeholder="$t('writeYourNotesHere')"></el-input>
                                    <div class="notes">
                                    </div>
                                    <div class="control">
                                        <el-link type="text" @click="item.noteEdit = ''"
                                                 class="px-3 py-1"
                                                 :underline="false">
                                            <i class="fas fa-trash-alt iq-text-danger"></i>
                                        </el-link>

                                        <div v-if="item.error" class="error">
                                            <i class="fas fa-exclamation-triangle"></i>
                                            {{ item.error }}
                                        </div>

                                        <div class="nowrap">
                                            <el-button type="text" @click="handleCancelNote(item)"
                                                       v-html="$t('cancel')"></el-button>
                                            <el-button type="primary"
                                                       @click="handleSaveNote(item)"
                                                       :disabled="item.error.length > 0"
                                                       v-html="$t('save')">
                                            </el-button>
                                        </div>
                                    </div>
                                    <el-link slot="reference" :underline="false"
                                             class="moreLikeLink"
                                             :class="[{active: item.note}]"
                                             @click="handleToggleNote(item)">
                                        <i class="fa-sticky-note fas"></i>
                                        <span class="label" v-html="$t('label.notes')"></span>
                                    </el-link>
                                </el-popover>
                                <el-link :underline="false" class="moreLikeLink"
                                         v-for="lang in languages" :key="lang.name"
                                         @click="handleTranslateItem(item,lang.name)"
                                         :class="{active: item.lang === lang.name}">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                         fill="none" style="position: relative;top: 5px; margin: -5px -4px 0 0;">

                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                              d="M7.99358 2.99986C8.54587 2.99986 8.99358 3.44758 8.99358 3.99986V4.70257H10.7807C10.7944 4.70228 10.8081 4.70228 10.8218 4.70257H12.3269C12.8792 4.70257 13.3269 5.15028 13.3269 5.70257C13.3269 6.25485 12.8792 6.70257 12.3269 6.70257H11.5715C11.3942 7.2829 11.1626 7.87554 10.8992 8.42696C10.5212 9.21867 10.0426 9.99981 9.50681 10.5411C9.49852 10.5495 9.49011 10.5579 9.48159 10.5664C9.98959 11.0649 10.5269 11.548 11.0479 11.9289L12.5915 7.71029C12.736 7.3153 13.1123 7.05297 13.5329 7.05392C13.9535 7.05487 14.3285 7.31889 14.4713 7.71452L16.6202 13.6705L17.4241 15.6184C17.6348 16.1289 17.3918 16.7135 16.8812 16.9242C16.3707 17.1349 15.7861 16.8919 15.5754 16.3813L15.0181 15.0311H11.9972L11.3972 16.401C11.1757 16.9069 10.5859 17.1374 10.0801 16.9159C9.57416 16.6943 9.34367 16.1046 9.56524 15.5987L10.3273 13.8588C9.44283 13.2896 8.59741 12.5108 7.92665 11.8415C7.75135 11.971 7.57421 12.0992 7.39996 12.2233C6.59587 12.7958 5.76548 13.3424 5.28655 13.621C4.80917 13.8987 4.19704 13.7368 3.91933 13.2595C3.64162 12.7821 3.80348 12.17 4.28086 11.8922C4.68465 11.6573 5.45919 11.1499 6.23999 10.594C6.33483 10.5265 6.42856 10.4591 6.52064 10.3922C5.97063 9.79109 5.43925 9.14158 5.1081 8.53017C4.84507 8.04454 5.02553 7.43764 5.51116 7.17461C5.99679 6.91158 6.60369 7.09203 6.86672 7.57766C7.1194 8.04418 7.56729 8.58074 8.08367 9.13589C8.08422 9.13535 8.08476 9.1348 8.0853 9.13426C8.39776 8.81855 8.76175 8.26185 9.09446 7.56512C9.22851 7.28441 9.35171 6.99312 9.46021 6.70257H3.49976C2.94747 6.70257 2.49976 6.25485 2.49976 5.70257C2.49976 5.15028 2.94747 4.70257 3.49976 4.70257H6.99358V3.99986C6.99358 3.44758 7.4413 2.99986 7.99358 2.99986ZM12.7743 13.0311H14.2633L13.524 10.9821L12.7743 13.0311Z"></path>
                                    </svg>
                                    <span class="label" v-html="$t('label.translate')"></span>
                                </el-link>
                                <el-link :underline="false" class="moreLikeLink"
                                         v-if="!noLikeThis"
                                         @click="handleMoreLikeClick(item)">
                                    <i class="fas fa-copy"></i>
                                    <span class="label" v-html="$t('label.moreLikeThis')"></span>
                                </el-link>

                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="darkness"></div>
        <div class="tour-step-note">
            <div class="title" v-html="tour.curStep.title"></div>
            <div class="text" v-html="tour.curStep.text"></div>
            <div class="control fixed">
                <div class="wrap">
                    <el-button type="default" @click="handleNextStep('skip')">
                        {{ $t('quickTour.skip') }}
                    </el-button>
                    <div class="breadcrumbs">
                        <div v-for="(crumb, ind) in tour.steps" :key="ind" @click="handleNextStep(ind)">
                            <i :class="['fa-circle', (tour.curStep.index === ind) ? 'fas' : 'far']"></i>
                        </div>
                    </div>
                    <div class="d-flex">
                        <el-button type="default" @click="handleNextStep('back')">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17.818" height="12.526"
                                 viewBox="0 0 17.818 12.526">
                                <path id="left-arrow"
                                      d="M5.812.188a.632.632,0,0,1,.9.889L2.158,5.63H17.18a.632.632,0,0,1,.638.629.64.64,0,0,1-.638.638H2.158L6.71,11.44a.645.645,0,0,1,0,.9.629.629,0,0,1-.9,0L.182,6.707a.633.633,0,0,1,0-.889Z"
                                      fill="currentColor"></path>
                            </svg>
                            {{ $t('quickTour.back') }}
                        </el-button>
                        <el-button type="primary" @click="handleNextStep('skip')" v-if="false">
                            {{ $t('quickTour.finish') }}
                        </el-button>
                        <el-button type="primary" @click="handleNextStep()" v-else>
                            {{ $t('quickTour.next') }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="17.818" height="12.526"
                                 viewBox="0 0 17.818 12.526">
                                <path id="left-arrow"
                                      d="M5.812.188a.632.632,0,0,1,.9.889L2.158,5.63H17.18a.632.632,0,0,1,.638.629.64.64,0,0,1-.638.638H2.158L6.71,11.44a.645.645,0,0,1,0,.9.629.629,0,0,1-.9,0L.182,6.707a.633.633,0,0,1,0-.889Z"
                                      fill="currentColor"></path>
                            </svg>
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

        <infinite-loading ref="infiniteLoading" @infinite="handleInfinite"
                          :distance="20">
            <div slot="no-more"></div>
            <div slot="no-results"></div>
        </infinite-loading>
        <el-backtop :target="`.fst-SearchList.${type}`" style="z-index: 5000" :bottom="20" :right="30"></el-backtop>
        <el-dialog
                title="Similar Documents"
                :visible.sync="dialogSimilarDocsVisible"
                :modalAppendToBody="true"
                width="750px"
                custom-class="dialog-custom text-left"
        />
    </div>
</template>

<script>
    import ElLink from 'element-ui/lib/link'
    import CollapseTags from '@/commons/components/CollapseTags.vue';
    import UserTags from '@/commons/components/UserTags.vue';
    import axios from "axios";
    import DocumentText from './DocumentText'
    import i18n from '@/commons/i18n';
    import _ from "lodash";
    import DocumentDevCard from "./DocumentDevCard";
    import CommonUtils from '@/commons/utils';
    import {mapState} from "vuex";
    import SummarizationBlock from "./actions/SummarizationBlock";


    const IqLink = {
        name: 'IqLink',
        mixins: [ElLink],
        methods: {
            handleClick(event) {
                if (!this.disabled) {
                    this.$emit('click', event);
                }
            },
        }
    };

    export default {
        name: "SearchList",
        components: {SummarizationBlock, IqLink, CollapseTags, UserTags, DocumentText},
        props: {
            type: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: () => ({})
            },
            filter: {
                type: Object,
                default: () => ({})
            },
            params: {
                type: Object,
                default: () => ({})
            },
            noLikeThis: {
                type: Boolean
            },
            showExportMenu: {
                type: Boolean
            },
            shiftYear: {
                type: Number,
                default: 0
            },
            fullUserTagList: {
                type: Array
            },
            tourStep: {
                type: String
            },
            active: {
                type: Boolean
            }
        },
        data() {
            return {
                maxNoteSize: 1000, // --- limit 1000 chars for user Note
                noLabels: false,
                exportLoading: false,
                companyCardId: '',
                // exportCheckedDisabled: true,
                // exportCheckedCount: 0,
                curYear: new Date().getFullYear(),
                dialogSimilarDocsVisible: false,
                exportMenuVisible: false,
                multiplier: 1000000000, // 1B
                result: {
                    total: 0,
                    offset: 0,
                    list: []
                },
                sortBy: {
                    field: 'month',
                    dir: 'DESC'
                },
                languages: [
                    {name: 'ru', label: this.$t('label.translate')},
                ],
                tour: {
                    curStep: {
                        title: 'Документ в результатах поиска',
                        text: `<p>содержит базовые <b>атрибуты</b> и <b>действия</b>, которые можно совершать с этим документом</p>
                               <p><b>атрибуты</b>: название, ключевые слова, фрагменты текста, год, автор и т.д.</p>
                               <p><b>действия</b>: перевести на русский, добавить тэг, найти похожий документ и т.д.</p>`,
                        index: 0
                    },
                    steps: [{
                        title: 'Документ в результатах поиска',
                        text: `<p>содержит базовые <b>атрибуты</b> и <b>действия</b>, которые можно совершать с этим документом</p>
                               <p><b>атрибуты</b>: название, ключевые слова, фрагменты текста, год, автор и т.д.</p>
                               <p><b>действия</b>: перевести на русский, добавить тэг, найти похожий документ и т.д.</p>`,
                    }, {
                        title: 'Раскройте полный текст',
                        text: 'нажав на его фрагмент',
                        actions: [{
                            type: 'highlight',
                            target: 'FullText'
                        }, {
                            type: 'showFullText'
                        }],
                    }, {
                        title: 'Откройте полную карточку документа',
                        text: 'нажав на заголовок',
                        actions: [{
                            type: 'highlight',
                            target: 'Title'
                        }],
                    }, {
                        title: 'Поставьте тэги',
                        text: 'на документ. Выберите существующий или создайте новый в появившемся меню.',
                        actions: [{
                            type: 'highlight',
                            target: 'Tag',
                        }, {
                            type: 'showTags'
                        }],
                    }, {
                        title: 'Переведите',
                        text: 'документ с английского на русский язык',
                        actions: [{
                            type: 'highlight',
                            target: 'Translate'
                        }],
                    }, {
                        title: 'Найдите похожие документы',
                        text: '',
                        actions: [{
                            type: 'highlight',
                            target: 'MoreLikeThis'
                        }],
                    }],
                    highlight: {
                        Tag: false,
                        Translate: false,
                        MoreLikeThis: false,
                        FullText: false,
                        Title: false
                    }
                },
            }
        },
        computed: {
            ...mapState({
                summarization: state => state.summarization,
                resultTranslation: state => state.resultTranslation,
            }),
            visibleResultList() {
                return _.filter(this.result.list, item => !!item.show);
            },
            userInfo() {
                return this.$store.state.userInfo;
            },
            isDev() {
                return this.userInfo.roles.indexOf('DEV') >= 0;
            },
            isAdmin() {
                return this.userInfo.roles.indexOf('ADMIN') >= 0;
            },
            isTranslationAvailable() {
                return this.userInfo.roles.includes('DEV');
            },
            exportCheckedDisabled() {
                return (this.result.list.filter(it => it.checked) || []).length < 1
            },
            exportCheckedCount() {
                return (this.result.list.filter(it => it.checked) || []).length
            },

            finishTour() {
                let _tour = this.tour;
                return _tour.curStep.index + 1 === _tour.steps.length
            },
            translationEnabled() {
                return this.resultTranslation.enabled;
            }
        },
        watch: {
            value(newVal) {
                let cloned = _.cloneDeep(newVal);

                this.result.list.forEach((oldItem, i) => {
                    let newItem = cloned.list[i];
                    if (newItem && oldItem.id === newItem.id) {
                        newItem.translation = oldItem.translation;
                    }
                })

                this.result = cloned;

                this.refresh();
                if (this.translationEnabled) {
                    this.$nextTick(() => this.translateNextDocument());
                }
            },
            fullUserTagList(newVal) {
                // this.getUserTagList();
                // console.log('new Taglist', newVal);
            },
            showExportMenu(newVal) {
                this.exportMenuVisible = newVal;
            },
            translationEnabled(enabled) {
                if (enabled && this.active) {
                    this.translateNextDocument();
                }
            },
        },
        created() {
            if (this.value) {
                this.result = _.cloneDeep(this.value);
                this.refresh();
            }
        },
        mounted() {
            this.exportMenuVisible = this.showExportMenu;
        },
        methods: {
            refresh() {
                this.result.list = this.result.list.map(item => {
                    let highlights = _.merge({full: {}, fragments: {}}, item.highlights),
                        gotFullText = false,
                        ftDesc = !highlights.full.description ? highlights.fragments.fullText : null,
                        // sysTags = item.systemTags && item.systemTags.length ? item.systemTags.filter(it => it.toLowerCase() !== 'spam') : [],
                        sysTags = [],
                        keywordsToHighlights = {};

                    item.original = item.original ? item.original : _.cloneDeep(item);

                    if (item.facetData && item.facetData.spam && item.facetData.spam.length) {
                        sysTags.push('SpAm');
                    }

                    for (let prop in highlights.full) {
                        if (!prop || prop === 'id' || prop === 'type') {
                            continue;
                        }
                        if (prop.startsWith('systemKeywords')) {
                            keywordsToHighlights[_.get(item, prop)] = highlights.full[prop];
                            continue;
                        }
                        _.set(item, prop, highlights.full[prop]);
                    }

                    // keywords
                    item.keywords = (item.systemKeywords || item.authorKeywords || []).map(kw => keywordsToHighlights[kw] || kw);

                    let desc = {
                        showFull: false,
                        full: item && item.description ? "<p>" + item.description.replace(/[\r\n]\s*/g, '\n').split("\n").join("</p>\n<p>") + "<p>" : '',
                        fragments: (() => {
                            let truncateDesc = _.truncate(_.clone(item.description), {
                                'length': 150,
                                'omission': '',
                                'separator': ' '
                            });
                            let frags = ftDesc ? ftDesc : highlights.fragments.description || [truncateDesc];
                            let str = '';
                            frags.forEach((item, index) => {
                                if (item.length) {
                                    str += `${index > 0 ? '...' : ''}${item}...<br>`;
                                }
                            });
                            return str;
                        })(),
                    };
                    if (!desc.fragments) {
                        if (highlights.fragments.fullText && highlights.fragments.fullText.length > 0) {
                            let frags = highlights.fragments.fullText;
                            let str = '';
                            frags.forEach((item, index) => {
                                if (item.length) {
                                    str += `${index > 0 ? '...' : ''}${item}...<br>`;
                                }
                            });
                            let _str = str.split('<br>');
                            desc.fragments = _str.slice(0, 2).join('<br>');
                            desc.full = _str.length > 2 ? _str.slice(0, 8).join('<br>') : null;

                        } else if (item.fullText) {
                            desc.fragments = _.truncate(_.clone(item.fullText), {
                                'length': 450,
                                'omission': '',
                                'separator': ' '
                            });
                            desc.full = _.truncate(_.clone(item.fullText), {
                                'length': 1200,
                                'omission': '',
                                'separator': ' '
                            });
                        }
                        gotFullText = true;
                    } else {
                        gotFullText = false;
                    }

                    let title = item.title || _.truncate(item.description, {'length': 100});
                    let sortFunc = (a, b) => {
                        let $a = a.indexOf('<em>') !== -1 ? 0 : 1;
                        let $b = b.indexOf('<em>') !== -1 ? 0 : 1;
                        return $a === $b ? 0 : $a > $b ? 1 : -1;
                    };
                    let countries = (item.countries || []).filter(it => it && it !== 'null').sort(sortFunc);
                    let companies = (item.companies || []).sort(sortFunc),
                        countriesFormat = countries.join('<i class="divider"></i>'),
                        companiesFormat = companies.join(', '),
                        urlLogo = (item.type == "Companies") ? ((item.icon && item.icon.url && !item.icon.url.includes('placeholder_')) ? item.icon.url.replace('f_jpg', 'f_auto,b_white,q_auto:eco') : 'noLogo2.png') : null,
                        founded = _.compact([countriesFormat, item.year]).join(', ');

                    let _website = (item.url || '').replace('www.', '').split('/')[2] || '',
                        _webAlias = {
                            't.me': 'Telegram',
                        },
                        translation = item.translation || {show: false, collapse: false},
                        _item = {
                            title: title.replace(/\s/g, '') ? title : '',
                            description: _.cloneDeep(desc),
                            date: moment(item.date).isAfter(moment()) ? '' : moment(item.date).format('DD.MM.YYYY'),
                            authorKeywords: (item.authorKeywords || []),
                            trends: (item.trends || []).sort(sortFunc),
                            website: item.url ? _webAlias[_website] || _website : '',
                            urlLogo: urlLogo,
                            countries: countries,
                            countriesFormat: countriesFormat,
                            checked: !!item.checked,
                            founded: founded,
                            error: '',
                            ftDesc: ftDesc,
                            note: item.userNote ? item.userNote.text : null,
                            noteEdit: item.userNote ? _.clone(item.userNote).text : null,
                            noteVisible: false,
                            userTags: item.tags || [],
                            companies: companies,
                            isViewed: item.isViewed ? item.isViewed : false,
                            lang: null,
                            sysTags: sysTags,
                            translation: translation,
                            // investmentFormat: (item.investmentTotal / this.multiplier).toFixed(1),
                            investmentFormat: this.$utils.toFinHuman(item.investmentTotal).number,
                            companyRank: item.companyRank,
                            companiesFormat: companiesFormat,
                            journalName: item.journalName,
                            show: true,
                            gotFullText: gotFullText,
                            // companiesFormat: (count => {
                            //     return count ? (count > 1 ? `${companies[0]} (+${count - 1})` : companies[0]) : '';
                            // })(companies.length),
                            isInFavorite: !!item.isInFavorite
                        };
                    return Object.assign({}, item, _item);
                });

            },
            handleOpenLink(link) {
                window.open(link, "_blank");
            },
            handleShowSummarization(state) {
                this.$store.commit('updateState', [{
                    path: 'summarization.show',
                    data: state,
                }])
            },
            cropFileName(name = "") {
                let _name = decodeURIComponent(_.last(name.split('/')))
                return _name.match(/pdf$/i) ? 'PDF document'
                    : _name.match(/xml$/i) ? 'XML document'
                        : 'Page ' + _name
            },
            toggleFullText(item) {
                if (this.$utils.getSelectionText() === "" && item.description.full) {
                    item.description.showFull = !item.description.showFull;
                    if (item.description.showFull) {
                        this.$services.userEvents.publish({
                            type: 'openFulltext',
                            data: {docIds: [{type: item.type, id: item.id}]}
                        });
                    }
                }
                this.toggleViewDoc(item, true);
            },
            toggleFavorites(item) {
                let query = [_.pick(item, ['id', 'type'])];
                let methodName = item.isInFavorite ? 'favoritesRemove' : 'favoritesAdd';
                let target = this.$refs[`list-item-${item.id}`] ? this.$refs[`list-item-${item.id}`][0] : [];

                this.$services.documents[methodName](query).prepare({target: target}).then(resp => {
                    if (resp.data) {
                        item.isInFavorite = !item.isInFavorite;

                        if (this.type === 'Favorites' && !item.isInFavorite) {
                            item.isRemove = true;
                            setTimeout(() => {
                                let index = this.result.list.findIndex(it => it === item);
                                this.result.list.splice(index, 1);
                            }, 1000)
                        }

                        setTimeout(() => this.toggleViewDoc(item, true), 300);
                        this.$emit('toggleFavorites', item);

                    }
                });
            },
            resetInfinite() {
                const $refs = this.$refs;
                if ($refs.list) $refs.list.scrollTop = 0;
                if ($refs.tbody) $refs.tbody.scrollTop = 0;
                if ($refs.infiniteLoading) {
                    $refs.infiniteLoading.stateChanger.reset();
                }
            },
            hideAllNotes() {
                this.result.list.forEach(it => {
                    it.noteVisible = false;
                })
            },
            showCard(id) {
                this.companyCardId = id;
                this.dialogCompanyCardVisible = true;
                this.$nextTick(() => {
                    this.$refs.CompanyCard.show(id);
                })
            },
            toggleViewDoc(item, status = true) {
                if (item && (item.isViewed !== true || status === false)) {
                    let action = status ? 'viewedAdd' : 'viewedRemove'
                    this.$services.documents[action]([{
                        id: item.id,
                        type: item.type
                    }]).then(resp => {
                        item.isViewed = status;
                        // if (status === false) this.noLabels = !this.noLabels;
                    });
                }
                this.hideAllNotes();
            },
            removeTagFromList(tagId) {
                this.$emit('removeTagFromList', tagId);
            },
            userTagAction(item) {
                this.$emit('userTagAction');
                this.toggleViewDoc(item, true);
            },
            formattedSum2(val) {
                let out = '';
                if (val) {
                    let index = "M",
                        dec = 1,
                        pow = 1000000;

                    if (val < 1000000) {
                        dec = 0;
                        index = "K";
                        pow = 1000;
                    }
                    val = (val / pow);
                    out = (this.toFin(val, dec) + '  ' + index);
                }
                return out;
            },
            formattedSum(val, multiplier) {
                let _val = Math.round(val / multiplier),
                    _pow = Math.pow(10, _val.toString().length - 2);
                _val = Math.round(_val / _pow) * _pow;
                return this.toFin(_val);
            },
            updateUserTagList(item) {
                this.$emit('updateUserTagList', item);
            },
            toFin(num, dec = 0) { // форматирование сумм в виде XXX XXX XXX
                return num ? num.toFixed(dec).toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ').replace(/\.0/, '') : 0;
            },
            deleteDocuments(documentIdentities) {
                let self = this;
                if (!_.isArray(documentIdentities) || documentIdentities.length === 0) {
                    self.$modal.alert('Document list empty');
                }
                self.$modal.confirm(`Delete ${documentIdentities.length} documents`, {
                    title: 'Confirm document deletion',
                    size: 'sm'
                }).then(() => {
                    self.$services.documents.deleteDocuments(documentIdentities).prepare().then(resp => {
                        // удаляем документы из списка
                        // эти изменения влияют только на список, фасеты и total не пересчитываются
                        const typeToIdsMap = _.chain(documentIdentities).keyBy('type').mapValues('id').value();
                        self.result.list = _.filter(self.result.list, i => !typeToIdsMap[i.type] || typeToIdsMap[i.type].indexOf(i.id) < 0);
                        self.result.total += resp.data;
                        self.$modal.alert(`Deleted ${resp.data} documents`, {title: 'Done'});
                    });
                });
            },
            showDevDialog(item, title) {
                this.$modal.dialog(DocumentDevCard, {
                    title,
                    size: 'center-wide',
                    params: {
                        document: item.original
                    }
                });
            },
            handleTranslateItem(item, lang) {
                let toTranslate = '',
                    delimiter = '^^^',
                    elem = this.$refs[`list-item-${item.id}`][0],
                    itemBlock = document.querySelector('.fst-SearchList.' + item.type) || document.querySelector('.fst-SearchList');

                itemBlock.scrollTo({
                    top: elem.offsetTop - 200,
                    behavior: "smooth"
                });

                item.translation.collapse = false;
                if (item.lang === lang) {
                    item.lang = null;
                    item.translation.show = false;
                } else if (item.translation && item.translation.title) {
                    item.lang = lang;
                    item.translation.show = true;
                } else {
                    item.lang = lang;
                    item.translation = {
                        title: '<div class="text-info">Translation in progress...</div>',
                        description: '<div class="text-center text-info my-3"><i class="fas fa-2x fa-spinner fa-pulse"></i></div>',
                        show: true,
                        collapse: false
                    };
                    // if (item.type === 'Company') {
                    //     toTranslate = delimiter + item.description.full;
                    // } else {
                    //     toTranslate = item.title + delimiter + item.description.full
                    // }

                    // this.$utils.translateText({
                    //     text: toTranslate.substring(0, 4999),
                    //     tl: lang
                    // }).then(function (response) {
                    //     if (response && response.data && response.data.message) {
                    //         let _resp = (response.data.message.content || '').split(delimiter);
                    //         item.translation = _.merge({}, item.translation, {
                    //             title: _resp[0] || item.title,
                    //             description: _resp[1],
                    //             show: true
                    //         });
                    //         itemBlock.scrollTo({
                    //             top: elem.offsetTop - 200,
                    //             behavior: "smooth"
                    //         });
                    //     }
                    // });
                    this.$services.documents.translate({
                        id: item.id,
                        type: item.type
                    }).then(resp => {
                        let _resp = resp.data;
                        item.translation = _.merge({}, item.translation, {
                            title: _resp.title || item.title,
                            description: _resp.description || item.description.full,
                            show: true
                        });
                        itemBlock.scrollTo({
                            top: elem.offsetTop - 200,
                            behavior: "smooth"
                        });
                    }, err => {
                        if (err.response && err.response.data.message) {
                            this.$message({
                                type: 'error',
                                showClose: true,
                                duration: 5000,
                                message: err.response.data.message
                            });
                            console.log('Translation Error: ', err.response.data.message)
                        }
                        item.translation = _.merge({}, item.translation, {
                            title: item.title,
                            description: item.description,
                            show: false
                        });
                    })
                }
                this.toggleViewDoc(item, true);
            },
            handleCollapseTranslation(item) {
                item.translation.collapse = !item.translation.collapse;
            },
            handleClearTranslate(item) {
                item.lang = null;
                item.translation.show = false;
            },
            handleExportDocs(params) {
                let query = {},
                    fileName = 'Documents.xlsx',
                    docType = this.type === "Favorites" ? 'Favorites' : 'Documents',
                    serviceType = this.type === "Favorites" ? 'favoritesExport' : 'documentExport';
                this.exportLoading = true;
                if (params && params.all) {
                    let filter = _.cloneDeep(this.filter);
                    query = {docIds: null, filter: filter};
                    fileName = 'Teqviser_' + docType + '_all(2k).xlsx';
                } else {
                    let _data = this.result.list.filter(item => item.checked),
                        ids = _.map(_data, (it) => {
                            return {id: it.id, type: it.type}
                        })
                    query = {docIds: ids, filter: null};
                    fileName = 'Teqviser_' + docType + '_selected(' + ids.length + ').xlsx';
                }
                axios({
                    url: this.$store.state.apiUrl + '/documents/' + serviceType,
                    method: 'POST',
                    data: JSON.stringify(query),
                    responseType: 'blob',
                    headers: {'Content-Type': 'application/json;charset=UTF-8'}
                }).then((resp) => {
                    // console.log('Checked query:', query, this.filter);
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(resp.data);
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.exportLoading = false;

                })

            },
            handleFavCheck(e, item) {
                // if (this.exportMenuVisible && !['BUTTON', 'A', 'SPAN', 'I'].includes(e.target.tagName)) {
                //     item.checked = !item.checked;
                // this.handleSelectDoc(item);
                // }
            },
            handleSortBy(item) {
                let _dir = this.dataSchema.find(it => it.field === item.field).dir,
                    _curSortDir = _.cloneDeep(this.dataSchema.find(it => it.field === item.field).dir);
                _.each(this.dataSchema, it => {
                    it.dir = '';
                });
                if (_curSortDir) {
                    this.dataSchema.find(it => it.field === item.field).dir = (_curSortDir === 'ASC') ? 'DESC' : 'ASC';
                } else {
                    this.dataSchema.find(it => it.field === item.field).dir = 'ASC';
                }
                this.sortBy = {
                    field: item.field,
                    dir: this.dataSchema.find(it => it.field === item.field).dir
                }
                this.$emit('sortBy', this.sortBy);
                if (this.$refs.tbody) this.$refs.tbody.scrollTop = 0;

            },
            handleSelectDoc(item) {
                // let _count = this.result.list.filter(it => it.checked).length;
                // this.exportCheckedCount = _count;
                // this.exportCheckedDisabled = _count < 1;
                this.$emit('handleSelectDoc', item)
            },
            handleSaveNote(item) {
                item.note = _.clone(item.noteEdit);
                let query = {
                    docId: item.id,
                    docType: item.type,
                    text: item.note
                };
                this.$services.documents.setNote(query).then(resp => {
                    item.noteVisible = false;
                })
            },
            handleCancelNote(item) {
                item.noteEdit = _.clone(item.note);
                item.noteVisible = false;
            },
            handleValidateUserNote(item) {
                if (item.noteEdit.length >= this.maxNoteSize) {
                    item.error = 'Max note size: ' + this.maxNoteSize + ' chars';
                } else {
                    item.error = '';
                }
            },
            handleInfinite(state) {
                // console.log('>>>>> Infinity!', state, this.type);
                let total = _.get(this.result, 'total') || 0;
                if (total > this.filter.count && total > this.result.list.length) {
                    this.$emit('infinite', state, this.sortBy);
                } else {
                    state.complete();
                }
            },
            handleToggleNote(item) {
                let status = !!_.clone(item.noteVisible);
                this.hideAllNotes();
                this.toggleViewDoc(item, true);
                item.noteVisible = !status;
            },
            handleCloseExportMenu() {
                this.result.list.forEach(it => {
                    it.checked = false
                })
                this.$emit('hideExportMenu');
                this.exportMenuVisible = false;
                this.exportCheckedCount = 0;
            },
            handleClickTitle(item) {
                item.locale = i18n.locale;
                if (this.$utils.getSelectionText() === "") {
                    switch (item.type) {
                        case 'Companies':
                            window.sessionStorage.setItem('companyCard', JSON.stringify(item));
                            window.open(this.$router.resolve({name: 'companyCard'}).href + '?id=' + item.id, '_blank');
                            break
                        // case 'Patents':
                        // window.sessionStorage.setItem('patentCard', JSON.stringify(item));
                        // window.open(this.$router.resolve({name: 'patentCard'}).href + '?id=' + item.id, '_blank');
                        // break;
                        // case 'Patents':
                        // case 'News':
                        // case 'ScienceLens':
                        // case 'ScienceOpen':
                        // case 'Science':
                        default:
                            window.sessionStorage.setItem('card', JSON.stringify(item));
                            window.open(this.$router.resolve({name: 'card'}).href + '?id=' + item.id + '&type=' + item.type, '_blank');
                            break;
                    }
                    this.toggleViewDoc(item, true);
                }
            },
            handleMoreLikeClick(item) {
                this.$emit('moreLikeThis', item)
            },
            getSelected() {
                if (window.getSelection) {
                    return window.getSelection().toString();
                } else if (document.getSelection) {
                    return document.getSelection().toString();
                } else {
                    var selection = document.selection && document.selection.createRange();
                    if (selection.text) {
                        return selection.text.toString();
                    }
                    return "";
                }
            },
            toggleIconSize() {
                let imgs = document.querySelectorAll('.fst-SearchList .list-item .logo');
                imgs.forEach(function (logo) {
                    logo.classList.toggle('middleIcon');
                })
            },
            handleTourStep(step) {
                this.$emit('tourStep', step);
                if (!step) {
                    this.resetTour();
                }
            },
            handleNextStep(step = '') {
                let self = this,
                    _tour = self.tour,
                    _timer;
                _.forEach(_tour.highlight, (it, i) => {
                    _tour.highlight[i] = false;
                });

                if (step === 'skip') {
                    self.handleTourStep(null);
                } else {
                    let rez = self.$utils.tourNextStep({
                        step: step,
                        tour: self.tour
                    });
                    if (rez === 'nextTourBlock') {
                        self.handleTourStep('finishTour');
                    } else if (rez === 'previousTourBlock') {
                        self.handleTourStep('4');
                    } else if (rez === 'showFullText') {
                        _timer = setTimeout(() => {
                            self.toggleFullText(self.result.list[0]);
                            _timer = setTimeout(() => {
                                self.toggleFullText(self.result.list[0]);
                                self.tour.highlight.FullText = false;
                            }, 2100);
                        }, 1300);
                    } else {
                        clearTimeout(_timer);
                        self.tour.highlight.FullText = false;
                    }
                }
            },
            resetTour() {
                let _tour = this.tour;
                _tour.curStep.index = 0;
                _tour.curStep.title = _tour.steps[0].title;
                _tour.curStep.text = _tour.steps[0].text;
                _.forEach(_tour.highlight, (it, i) => {
                    _tour.highlight[i] = false;
                });
            },

            translateNextDocument() {
                if (this.$store.state.resultTranslation.active) {
                    console.debug("translation already running");
                    return;
                }
                this.$store.commit('updateTranslationProcess', true);
                this._translateNextDocument();
            },
            _translateNextDocument() {
                let self = this;
                var item = _.find(self.result.list, i => !i.translation.title && !i.translation.description);
                if (!item) {
                    self.$store.commit('updateTranslationProcess', false);
                    return;
                }
                self.$services.documents.translationQueue({
                    id: item.id,
                    type: item.type
                }).then(resp => {
                    let doc = resp.data.document;
                    if (doc) {
                        item.translation = _.merge({}, item.translation, {
                            title: doc.title || item.title,
                            description: doc.description || item.description.full,
                            show: true,
                            collapse: true
                        });
                    }

                    // чтобы этот цикл прервался после уничтожения компонента (например при переходе из поиска в аналитику),
                    // значение нужно брать из стора напрямую, потому что computed перестает обновляться
                    let enabled = this.$store.state.resultTranslation.enabled;
                    if (self.active && enabled) {
                        setTimeout(() => self._translateNextDocument(), resp.data.backoff);
                    } else {
                        self.$store.commit('updateTranslationProcess', false);
                    }
                }, err => self.$store.commit('updateTranslationProcess', false))
                    .catch(e => self.$store.commit('updateTranslationProcess', false))
            }
        }
    }
</script>

<style lang="scss">

    .fst-SearchList {
        //height: 100%;
        overflow-y: auto;
        background: $iq-color-blue-lighter;

        .b {
            font-weight: 900;
        }

        .exportBtn, .exportMenu {
            position: absolute;
            top: 50px;
            left: 900px;
            background: #fff;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            box-shadow: $iq-shadow;
        }

        &.Favorites {
            .exportBtn, .exportMenu {
                top: 4px;
            }
        }

        .exportBtn {
            cursor: pointer;
            width: 50px;
            height: 50px;
            border: 1px solid $iq-color-blue-light;
        }

        .exportMenu {
            position: absolute;
            box-sizing: border-box;
            padding: 12px 10px;
            font-size: 14px;
            background: #fff;
            align-items: stretch;
            width: 190px;
            border: 1px solid $iq-color-blue-light;

            .btn {
                background: $iq-color-blue-light;
                color: $iq-color-blue;
                font-variant: all-small-caps;
                font-size: 14px;
                font-weight: 500;
                padding: 7px 10px;
                line-height: 1;
                border-radius: 5px;
                border: none;
                display: block;
                margin-bottom: 5px;
                cursor: pointer;
                transition: all .25s ease;
                text-align: left;

                &[disabled] {
                    background: $iq-color-grey-ultra-light;
                    color: $iq-color-blue-medium;
                    cursor: not-allowed;

                    &:hover {
                        background: $iq-color-grey-ultra-light;
                        color: $iq-color-blue-medium;
                    }
                }

                &:last-child {
                    margin-bottom: 0;
                }

                &:hover {
                    background: $iq-color-blue-medium;
                }
            }

            .closeMenu {
                position: absolute;
                font-size: 18px;
                padding: 5px;
                top: -8px;
                right: -25px;
                color: $iq-color-blue-medium;
                cursor: pointer;
            }
        }

        .list-item-container {
            display: flex;
            align-items: flex-start;
            //padding-top: 20px;
            width: 850px;
            //max-width: calc(100vw - 670px);
            min-width: 600px;
            transition: $fullScreenTransition;

            &:first-of-type {
                padding-top: 0;
            }

            > .el-checkbox {
                margin: 2px 15px 0 0;

                .el-checkbox__inner {
                    width: 22px;
                    height: 22px;

                    &:after {
                        border-width: 2px;
                        height: 10px;
                        left: 7px;
                        top: 2px;
                        width: 5px;
                    }
                }
            }
        }

        .favs {
            span.label {
                margin-left: 5px;
            }

            &.noLabels {
                span.label {
                    display: none;
                }
            }

            &.highlightNote {
                > * {
                    &:nth-child(1) {
                        padding: 2px 6px;
                        border-radius: 5px;
                        transition: none;
                        background: $iq-color-blue;
                        color: #fff !important;

                        .el-link {
                            color: #fff !important;
                        }
                    }
                }
            }

            &.highlightTranslate {
                > * {
                    &:nth-child(2) {
                        padding: 2px 6px;
                        border-radius: 5px;
                        transition: none;
                        background: $iq-color-blue;
                        color: #fff !important;

                        svg {
                            fill: #fff !important;
                        }
                    }
                }
            }

            &.highlightMoreLikeThis {
                > * {
                    &:nth-child(3) {
                        padding: 2px 6px;
                        border-radius: 5px;
                        transition: none;
                        background: $iq-color-blue;
                        color: #fff !important;

                        .el-link {
                            color: #fff !important;
                        }
                    }
                }
            }
        }

        .fullTextDesc {
            margin-bottom: 10px;

            & + div {
                color: $iq-color-grey-blue;
                font-size: 13.5px;
                line-height: 1.4;
                margin-bottom: 7px;

                &:before {
                    content: "Abstract:";
                    display: block;
                    margin-bottom: 3px;
                    font-weight: 500;
                }
            }

            > div {
                & + div:before {
                    content: "...";
                }
            }
        }

        .highlightTitle {
            .title-block {
                background: $iq-color-blue;
                padding: 3px 10px 0;
                border-radius: 5px;

                a {
                    color: #fff !important;
                }
            }
        }

        .highlightDescription {
            .description {
                padding: 10px 15px 0 !important;
                background: #3064F2;
                color: #fff !important;
            }
        }

        .title-block {
            .titleNum {
                display: flex;
                gap: 7px;
                align-items: flex-start;
            }
        }

        // --- .list-item see @ commons.scss

    }

</style>
